module.exports = __webpack_public_path__ + "img/CV.fb604dba.svg";